var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrnamentalSwirl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "       M120 480       C180 360, 320 340, 420 260       C500 200, 460 120, 360 140       C260 160, 220 240, 260 300     ",
    fill: "none",
    stroke: "#8A6A4F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "       M160 500       C240 420, 360 380, 440 300     ",
    fill: "none",
    stroke: "#9B7A5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrnamentalSwirl);
export default __webpack_public_path__ + "static/media/ornamental-swirl.f6c846db3d7e832ee66b64c30e22ff2a.svg";
export { ForwardRef as ReactComponent };